export class FabricWeaveRequest{
    fabricWeaveId : number;
    updatedUser:string;
    fabricWeaveName?: string;
    fabricWeaveCode?: string;
    fabricWeaveImageName ?: string;
    fabricWeaveImagePath? : string
    isActive?: boolean;
    createdAt? : Date | any;
    createdUser? : string;
    updatedAt ?: Date | any;
    versionFlag ?: number;
    fabricTypeId? : number
    plantId?:number;
    plantName?:string
    constructor(fabricWeaveId : number,updatedUser:string,versionFlag?:number,
        isActive?:boolean,fabricWeaveName?: string,
        fabricWeaveCode?: string,
        fabricWeaveImageName ?: string,
        fabricWeaveImagePath? : string,
        plantId?:number,
    plantName?:string
    )
    {
        this.fabricWeaveId = fabricWeaveId;
        this.updatedUser = updatedUser;
        this.versionFlag = versionFlag;
        this.isActive = isActive;
        this.fabricWeaveName=fabricWeaveName;
        this.fabricWeaveImageName=fabricWeaveImageName;
        this.fabricWeaveImagePath=fabricWeaveImagePath;
        this.plantId=plantId,
        this.plantName=plantName;
    }
}

